import React, { PropTypes, Component } from 'react';
import AudioPlayer from 'react-cl-audio-player';

class Mp3 extends React.Component {

    constructor(props) {
        super(props);
        this.playerRef = null;
        this.state = {
            isClient: false
        };
    }

    componentWillUnmount() {
        // ensure audio stops when leaving article
        if (this.playerRef) {
            this.playerRef.pause();
        }
    }

    componentDidMount() {
        this.setState({
            isClient: true
        });
    }

    render() {
        if (!this.state.isClient) {
            return null;
        }

        let { file, cover, artist, song } = this.props;
        if (!song) {
            song = file;
        }

        file = file.replace(" ", "+");
        const url = "https://s3.amazonaws.com/you-phoria/" + file;

        const songs = [
            {
                url,
                cover,
                artist: {
                    name: artist,
                    song: song
                }
            }
        ];
        return (
            <div>
                <AudioPlayer songs={songs} autoplay={false} ref={element => {this.playerRef = element}} />
            </div>
        );
    }
}

export default Mp3;


// WEBPACK FOOTER //
// ./src/components/embedded/Mp3.jsx